import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("This will "),
  /*#__PURE__*/_createElementVNode("strong", null, "permanently delete"),
  /*#__PURE__*/_createTextVNode(" this template:")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("This will "),
  /*#__PURE__*/_createElementVNode("strong", null, "archive"),
  /*#__PURE__*/_createTextVNode(" this template.")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("This will set the template as "),
  /*#__PURE__*/_createElementVNode("strong", null, "Published"),
  /*#__PURE__*/_createTextVNode(".")
], -1)
const _hoisted_5 = {
  key: 2,
  class: "mt-8"
}
const _hoisted_6 = {
  key: 0,
  class: "mt-6 border border-gray-400 rounded"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "px-4 py-2 bg-gray-100 border-b border-gray-400" }, "Key Programme Details", -1)
const _hoisted_8 = { class: "w-full px-4 py-4 border-b border-gray-300" }
const _hoisted_9 = { class: "text-xl font-medium capitalize" }
const _hoisted_10 = { class: "mt-2" }
const _hoisted_11 = { class: "capitalize" }
const _hoisted_12 = { class: "capitalize" }
const _hoisted_13 = { class: "capitalize" }
const _hoisted_14 = { class: "capitalize" }
const _hoisted_15 = { class: "mt-2 ml-2 list-disc list-inside" }
const _hoisted_16 = { class: "w-full table-auto" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "font-bold text-left border-b-2 border-black divide-x-2 divide-gray-400" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "w-1/5 px-2 py-2" }, "Country"),
    /*#__PURE__*/_createElementVNode("th", { class: "w-3/5 px-2 py-2" }, "Pricing")
  ])
], -1)
const _hoisted_18 = { class: "w-64 px-2 py-3 capitalize" }
const _hoisted_19 = { class: "px-2 py-3" }
const _hoisted_20 = { class: "capitalize" }
const _hoisted_21 = { class: "capitalize" }
const _hoisted_22 = { class: "px-4 py-4 bg-gray-100 border-t border-gray-400" }
const _hoisted_23 = {
  key: 1,
  class: "mt-6"
}
const _hoisted_24 = { class: "flex flex-wrap gap-4 py-4 md:space-y-0 md:space-x-4 md:flex-none" }

import { useRoute, useRouter } from "vue-router";
import { ref } from "vue";

import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import StoryblockDescription from "@/components/StoryblockDescription.vue";
import DefaultButton from "@/components/DefaultButton.vue";
import RouterButton from "@/components/RouterButton.vue";
import PriceDisplay from "@/components/PriceDisplay.vue";
import ReadonlyTags from "@/components/ReadonlyTags.vue";
import TitleHeader from "@/components/TitleHeader.vue";
import ListRowItem from "@/components/ListRowItem.vue";
import RoleGuard from "@/components/RoleGuard.vue";
import TabGroup from "@/components/TabGroup.vue";

import api from "@/api/api";
import { useGlobalStore } from "@/store";
import { Template, CreateTemplateRequest } from "@/types";
import AlertCard from "@/components/AlertCard.vue";
import { storeToRefs } from "pinia";
import { userHasRole } from "@/utils/roles";
import { deserializeSlug } from "@/utils/slugify";


export default /*#__PURE__*/_defineComponent({
  __name: 'TemplatePage',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const globalStore = useGlobalStore();
const { user_roles } = storeToRefs(globalStore);

console.log("user_roles", user_roles);

const isLoading = ref(false);
const isSaving = ref(false);
const isArchiveConfirmationOpen = ref(false);
const isUnarchiveConfirmationOpen = ref(false);
const isDeleteConfirmationOpen = ref(false);
const canDelete = ref(false);

const moodle_course = ref({} as any);
const template = ref({} as Template);
const story = ref({});
const tabs = [
  {
    id: "summary",
    name: "Summary",
  },
  {
    id: "course_description",
    name: "Course Details",
  },
];

const selectedTab = ref("summary");

async function duplicateTemplate() {
  try {
    isSaving.value = true;

    //Create a date string in the format DDMMYYYY
    const date = new Date();
    const dateString = `${date.getDate().toString().padStart(2, "0")}${(date.getMonth() + 1).toString().padStart(2, "0")}${date.getFullYear()}`;

    const data: CreateTemplateRequest = {
      name: `${template.value.name} (Duplicate) ` + dateString,
      description: template.value.description ? template.value.description : "empty description",
      type: template.value.type,
      level: template.value.level,
      subscription: template.value.subscription,
      confirmation_message: template.value.confirmation_message ? template.value.confirmation_message : "0",
      delivery: template.value.delivery,
      registration_method: template.value.registration_method,
      storyblok_id: template.value.storyblok_id,
      storyblok_slug: template.value.storyblok_slug,
      countries: template.value.countries,
      required_roles: template.value.required_roles,
      requires_subscription: template.value.requires_subscription,
      moodle_course_id: template.value.moodle_course_id,
      order: template.value.order,
      merchant_product_code: template.value.merchant_product_code
    };

    const response = await api.templates.createTemplate(data);

    globalStore.toast("SUCCESS", "Template duplicated");
    // TODO: Router.push() not working.
    window.location.href = `/dashboard/courses/templates/${response.data.template.id}`;
  } catch (e) {
    console.log("ERROR", e);
    isSaving.value = false;
    globalStore.toast("ERROR", "Error duplicating Template");
  }
}

async function deleteTemplate() {
  try {
    await api.templates.deleteTemplate(template.value.id);
    globalStore.toast("SUCCESS", "Template deleted");
    return router.push({ name: "Course_Templates" });
  } catch (e) {
    isDeleteConfirmationOpen.value = false;
    globalStore.toast("ERROR", "Error deleting Template");
  }
}

async function archiveTemplate() {
  try {
    const response = await api.templates.updateStatus(template.value.id, {
      status: "archived",
    });

    template.value = response.data.template;

    globalStore.toast("SUCCESS", "Template archived");
    isArchiveConfirmationOpen.value = false;
    return router.push({ name: "Course_Template", params: { id: template.value.id } });
  } catch (e) {
    console.log(e);
    isArchiveConfirmationOpen.value = false;
    globalStore.toast("ERROR", "Error archiving Template");
  }
}

async function unarchiveTemplate() {
  try {
    const response = await api.templates.updateStatus(template.value.id, {
      status: "published",
    });

    template.value = response.data.template;

    globalStore.toast("SUCCESS", "Template unarchived");
    isUnarchiveConfirmationOpen.value = false;
    return router.push({ name: "Course_Template", params: { id: template.value.id } });
  } catch (e) {
    console.log(e);
    globalStore.toast("ERROR", "Error unarchiving Template");
  }
}

async function checkCanDelete() {
  try {
    const response = await api.templates.canDeleteTemplate(template.value.id);
    canDelete.value = response.data.canDelete;
  } catch (e) {
    console.log("ERROR", e);
    globalStore.toast("ERROR", "Error checking if Template can be deleted");
  }
}

async function fetchTemplate() {
  try {
    isLoading.value = true;
    // If Number(route.params.id) is NaN, redirect to Course Templates page
    if (isNaN(Number(route.params.id))) {
      throw new Error("Invalid Template ID");
    }

    const response = (await api.templates.getTemplate(Number(route.params.id), { events: true })).data;

    template.value = response.template;
    story.value = response.story;

    if (template.value.moodle_course_id) {
      moodle_course.value = (await api.templates.getMoodleCourse(template.value.moodle_course_id)).data.course;
    }
    // If user is admin admin or courses-admin, check if template can be deleted
    if (userHasRole(user_roles.value, ["admin", "courses-admin"])) {
      await checkCanDelete();
    }

    isLoading.value = false;
  } catch (error) {
    console.log("ERROR", error);
    globalStore.toast("ERROR", "Error fetching Template");
    window.location.href = "/error";
  }
}

fetchTemplate();

if (userHasRole(user_roles.value, ["l4a-trainer"])) {
  window.location.href = "/error";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(ConfirmationModal, {
            isOpen: isDeleteConfirmationOpen.value,
            onClose: _cache[0] || (_cache[0] = ($event: any) => (isDeleteConfirmationOpen.value = false)),
            onDelete: deleteTemplate,
            buttonText: "Confirm Deletion"
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["isOpen"]),
          _createVNode(ConfirmationModal, {
            isOpen: isArchiveConfirmationOpen.value,
            onClose: _cache[1] || (_cache[1] = ($event: any) => (isArchiveConfirmationOpen.value = false)),
            onDelete: archiveTemplate,
            buttonText: "Confirm Archival"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["isOpen"]),
          _createVNode(ConfirmationModal, {
            isOpen: isUnarchiveConfirmationOpen.value,
            onClose: _cache[2] || (_cache[2] = ($event: any) => (isUnarchiveConfirmationOpen.value = false)),
            onDelete: unarchiveTemplate,
            buttonText: "Confirm Unarchival"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["isOpen"])
        ]))
      : _createCommentVNode("", true),
    (template.value.status === 'archived')
      ? (_openBlock(), _createBlock(AlertCard, {
          key: 1,
          type: "warning"
        }, {
          default: _withCtx(() => [
            _createTextVNode("This template is currently Archived ")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(TitleHeader, {
        title: template.value.name
      }, null, 8, ["title"])
    ]),
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(TabGroup, {
            tabs: tabs,
            selectedTab: selectedTab.value,
            onSelect: _cache[3] || (_cache[3] = (tab) => selectedTab.value = tab)
          }, null, 8, ["selectedTab"]),
          (selectedTab.value === 'summary')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("h2", _hoisted_9, _toDisplayString(template.value.name), 1),
                  _createElementVNode("p", _hoisted_10, _toDisplayString(template.value.description), 1)
                ]),
                _createVNode(ListRowItem, { title: "Course Level" }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_11, _toDisplayString(template.value.level), 1)
                  ]),
                  _: 1
                }),
                _createVNode(ListRowItem, { title: "Course Type" }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(deserializeSlug)(template.value.type)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(ListRowItem, { title: "Delivery Method" }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(deserializeSlug)(template.value.delivery)), 1)
                  ]),
                  _: 1
                }),
                (['e-learning', 'webinar'].includes(template.value.delivery))
                  ? (_openBlock(), _createBlock(ListRowItem, {
                      key: 0,
                      title: "Moodle Course"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_14, _toDisplayString(moodle_course.value.displayname), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(ListRowItem, {
                  title: "Registration Rules and Method",
                  flex: false
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("ul", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(template.value.required_roles, (role) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: role.id
                        }, _toDisplayString(_ctx.$t(role.name)), 1))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(ListRowItem, {
                  title: "Countries and Pricing",
                  flex: false
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("table", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(template.value.countries, (country, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            class: "border-b border-gray-400 divide-x-2 divide-gray-400 odd:bg-gray-200",
                            key: index
                          }, [
                            _createElementVNode("td", _hoisted_18, _toDisplayString(country.country), 1),
                            _createElementVNode("td", _hoisted_19, [
                              _createVNode(PriceDisplay, {
                                locale: "en-GB",
                                price: country.pricing,
                                currency: country.currency,
                                vat: country.vat
                              }, null, 8, ["price", "currency", "vat"])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(ListRowItem, { title: "Requires a subscription?" }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_20, _toDisplayString(template.value.requires_subscription ? _ctx.$t("yes") : _ctx.$t("no")), 1)
                  ]),
                  _: 1
                }),
                (template.value.subscription)
                  ? (_openBlock(), _createBlock(ListRowItem, {
                      key: 1,
                      title: "Subscription Level on Completion"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_21, _toDisplayString(template.value.subscription !== "no-change" ? _unref(user_roles).find(i => i.name === template.value.subscription)!.display_name : "No change"), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(ReadonlyTags, {
                    tags: template.value.tags!
                  }, null, 8, ["tags"])
                ])
              ]))
            : _createCommentVNode("", true),
          (selectedTab.value === 'course_description')
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createVNode(StoryblockDescription, { story: story.value }, null, 8, ["story"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!isLoading.value)
      ? (_openBlock(), _createBlock(RoleGuard, {
          key: 3,
          roles: ['admin', 'courses-admin']
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_24, [
              _createVNode(RouterButton, {
                type: "primary",
                to: { name: 'Edit_Course_Template', params: { id: template.value.id } }
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Edit Course Template")
                ]),
                _: 1
              }, 8, ["to"]),
              _createVNode(DefaultButton, {
                type: "primary",
                loading: false,
                onAction: duplicateTemplate,
                disabled: false
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Duplicate Course Template")
                ]),
                _: 1
              }),
              (template.value.status !== 'archived')
                ? (_openBlock(), _createBlock(DefaultButton, {
                    key: 0,
                    type: "danger",
                    onAction: _cache[4] || (_cache[4] = ($event: any) => (isArchiveConfirmationOpen.value = true)),
                    loading: false,
                    disabled: false
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Archive Course Template")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (template.value.status === 'archived')
                ? (_openBlock(), _createBlock(DefaultButton, {
                    key: 1,
                    type: "danger",
                    onAction: _cache[5] || (_cache[5] = ($event: any) => (isUnarchiveConfirmationOpen.value = true)),
                    loading: false,
                    disabled: false
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Unarchive Course Template")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(DefaultButton, {
                type: "danger",
                class: _normalizeClass([
      !canDelete.value ? 'cursor-not-allowed !border-gray-600 !bg-gray-600 !hover:bg-gray-600 !hover:border-gray-600' : '']),
                onAction: _cache[6] || (_cache[6] = ($event: any) => (isDeleteConfirmationOpen.value = true)),
                loading: false,
                disabled: !canDelete.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Delete Course Template")
                ]),
                _: 1
              }, 8, ["class", "disabled"])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})